import { storage } from '@/lib/utils/storage';
import { IMPERSONATION_KEY } from '@/lib/utils/constants';
import { toast } from '@/lib/hooks/use-toast';

/**
 * Bordes A12 (servidor): la sesión de soporte («Entrar como») dura 4 horas y no se renueva;
 * el refresh contesta 401. La regla vive acá: el cliente HTTP la usa al fallar el refresh y la
 * app muestra el aviso después de la recarga. Se habla al admin de plataforma (vos, como el panel).
 */
export const AVISO_SOPORTE_VENCIDO = {
  title: 'Terminó la sesión de soporte',
  description:
    'La sesión de soporte dura 4 horas y no se renueva. Si hace falta seguir, volvé a entrar con «Entrar como» desde la ficha de su empresa.',
};

const MARCA_DEL_AVISO = 'aviso_soporte_vencido';

/** ¿Esta pestaña está en «Entrar como»? Lo dice el respaldo de la sesión del admin. */
export function enSesionDeSoporte(): boolean {
  return storage.get(IMPERSONATION_KEY) != null;
}

/**
 * Vuelve a la sesión del admin (la misma salida que «Volver a mi cuenta»), deja el aviso para
 * después de la recarga y va al panel. El store se carga al momento para no atar el cliente
 * HTTP al store desde el arranque.
 */
export async function terminarSoporteVencido(): Promise<void> {
  const { useAuthStore } = await import('@/features/auth/store/auth-store');
  useAuthStore.getState().exitImpersonation();
  try {
    window.sessionStorage.setItem(MARCA_DEL_AVISO, '1');
  } catch {
    // Sin sessionStorage el panel abre igual; sólo falta el aviso.
  }
  window.location.href = '/plataforma/empresas';
}

/** Si la carga anterior terminó una sesión de soporte vencida, lo dice una sola vez. */
export function mostrarAvisoPendienteDeSoporte(): void {
  try {
    if (window.sessionStorage.getItem(MARCA_DEL_AVISO) !== '1') return;
    window.sessionStorage.removeItem(MARCA_DEL_AVISO);
  } catch {
    return;
  }
  toast(AVISO_SOPORTE_VENCIDO);
}
